import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TicketCountWidget from './TicketCountWidget';
import { Rub } from '../../utils/Symbols'

class TicketsSelector extends Component {

    render() {
        return (
            <div className="tickets-selector-row row">
                <div className="col-12 col-sm-7 tickets-selector-perfname-container">
                    <div className="tickets-selector-perfname desktop-only">
                        {this.props.ticketSet.name}
                    </div>
                    <div className="tickets-selector-small-text desktop-only">
                        {this.props.comment}
                    </div>
                    <div className="tickets-selector-small-text mobile-only">
                        {this.props.ticketSet.name}
                    </div>
                </div>

                <div className="col-6 col-sm-2 tickets-selector-amount-container tickets-selector-big-text tickets-selector-price">
                    {Number(this.props.ticketSet.price)} <Rub />
                </div>

                <div className="col-6 col-sm-3 tickets-selector-amount-container tickets-selector-counter-field"
                    title={this.getTitle()}>
                    <TicketCountWidget
                        id={`${this.props.seatType}_amount`}
                        value={this.props.chosenTickets.count || 0}
                        onChange={(count) => this.handleTicketsChange(count)}
                        increaseAllowed={this.props.increaseAllowed} />
                </div>
            </div>
        );
    }

    handleTicketsChange = (proposedCount) => {
        const correctedCount = this.getCorrectTicketsCount(proposedCount);
        this.props.onChange({
            key: this.props.ticketSet.id,
            name: this.props.ticketSet.name,
            type: this.props.ticketSet.type,
            price: this.props.ticketSet.price,
            count: correctedCount,
            bookRandomly: true
        });
    }

    getCorrectTicketsCount = (proposedCount) => {
        if (proposedCount > this.props.maxCount) {
            return this.props.maxCount;
        } else if (proposedCount < 0) {
            return 0;
        } else {
            return proposedCount;
        }
    }

    getTitle = () => {
        return (
            'Вы можете приобрести не больше ' 
            + this.props.maxCount 
            + ' билетов этого типа за раз. '
            + 'Всего доступно в данной категории: ' 
            + this.props.ticketSet.amount_available
        )
    }
}

TicketsSelector.propTypes = {
    ticketSet: PropTypes.object.isRequired,
    chosenTickets: PropTypes.object,
    onChange: PropTypes.func
}

TicketsSelector.defaultProps = {
    chosenTickets: {}
}

export default TicketsSelector;
